import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IInternalUser from '../../interfaces/IInternalUser';
import { IPaginationReturn } from '../../interfaces/IPaginationReturn';

const useInternalUserService = () => {
  const request = useRequest<IInternalUser>();
  const path = 'user';

  const listById = async (id: string): Promise<IInternalUser> => {
    return await request
      .getOne({ path: `${path}/${id}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const list = async (queryParams: string): Promise<IPaginationReturn<IInternalUser[]>> => {
    return await request
      .getManyPaginated({ path: `${path}?${queryParams}`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async (resource: IInternalUser): Promise<IInternalUser> => {
    return await request
      .post({
        path: `${path}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: string, resource: IInternalUser): Promise<IInternalUser> => {
    return await request
      .put({
        path: `${path}/${id}`,
        sendAuthorization: true,
        body: resource,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: string): Promise<void> => {
    return await request
      .remove({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(() => {})
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { list, listById, create, update, remove };
};

export { useInternalUserService };
